import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { catchError } from 'rxjs/operators';
import { UserService } from '../shared/services/user.service';

@Component({
  selector: 'app-contact-info',
  templateUrl: './contact-info.component.html',
  styleUrls: ['./contact-info.component.scss']
})
export class ContactInfoComponent implements OnInit {
  mobileNumber:any;
  selectedCountry:any;
  country = null;
  preselectedCountry = null;
  email:any;
  isLoading=false;
  constructor(public userService: UserService,    private dialogRef: MatDialogRef<ContactInfoComponent>,) { }

  ngOnInit(): void {
    this.mobileNumber=null;
    this.email=this.userService.getUser().Email;
    this.isLoading =true;
    this.userService.getMobileNumberForEmail(this.email).subscribe((result) =>
    {        
        if (result && result.data)
        {
          this.isLoading =false;
            this.mobileNumber = result.data.MobileNumber;                      
            this.preselectedCountry = result.data.SelectedCountryID;                       
        }
    }, (e) => {
       
    });
  }
  
  hide(){
    this.dialogRef.close();
  }
  updateMobileNumber(){

    if (this.preselectedCountry && this.preselectedCountry.ID)
    {

    } else {
        alert('Please select an valid country code!');
        return;
    }
    if (this.mobileNumber) {
     return this.userService.updateMobileNumberForEmail(this.mobileNumber, this.preselectedCountry.ID).subscribe((result) => {
            result.data = result;
            alert(result.data.ErrorMessage);
            if (result.data.ErrorCode == 200) {
              this.dialogRef.close();
            }
        }, (e) => {
            console.log(e);
            alert('Error occured while processing your request!')
        });
    } else {
        alert('Please provide an valid mobile phone number!')
    }                   
}
}
